export enum ValueTypeEnum {
  NUMERICAL = 'NUMERICAL',
  IMAGE = 'IMAGE',
}
